"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        backgroundColor: '#f7fcfc',
        padding: '20px',
        height: '100vh',
    },
    title: {
        color: '#646464',
        fontSize: 24,
        fontWeight: 400,
        margin: '10px 20px 0 20px',
    },
    formFields: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '60px',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '90%',
        background: '#F7FCFC',
    },
    input: {
        background: '#f7fcfc',
    },
    label: {
        color: '#2eaba4',
    },
    closeBtn: {
        width: '30px',
        height: '30px',
        color: '#30aba3',
        marginLeft: '88vw',
    },
    btnContainer: {
        display: 'flex',
        marginTop: '30px',
        marginRight: '30px',
        justifyContent: 'flex-end',
        flexDirection: 'row',
    },
    cancelBtn: {
        backgroundColor: 'transparent !important',
        marginRight: '15px',
        color: '#2eaba4',
        border: '1px solid #2eaba4',
    },
    legalCopy: {
        color: '#646464',
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '21px',
        margin: '10px 20px 0 20px',
    },
    viewMore: {
        color: '#2eaba4',
        fontSize: 14,
        fontWeight: 400,
        marginLeft: '20px',
        marginTop: '10px',
    },
    error: {
        color: 'red',
    },
    agreeBtn: {
        backgroundColor: '#2eaba4',
        color: '#FFF',
        '&:focus': {
            backgroundColor: '#2eaba4 !important',
            color: '#FFF',
        },
        '&:hover': {
            backgroundColor: '#2eaba4 !important',
            color: '#FFF',
        },
    },
}); });
var DocumentPageSignatureInputDialog = function (_a) {
    var isInitials = _a.isInitials, onClose = _a.onClose, onSubmit = _a.onSubmit, open = _a.open, requiredImpression = _a.requiredImpression;
    var classes = useStyles();
    var _b = react_1.useState(false), isViewMoreOpen = _b[0], setIsViewMoreOpen = _b[1];
    var _c = react_1.useState(''), impression = _c[0], setImpression = _c[1];
    var _d = react_1.useState(false), wasSubmitted = _d[0], setWasSubmitted = _d[1];
    react_1.useEffect(function () {
        if (open) {
            setIsViewMoreOpen(false);
            setImpression('');
            setWasSubmitted(false);
        }
    }, [open]);
    var getImpressionError = function (impression) {
        if (!impression)
            return 'Cannot be blank';
        var isImpressionInvalid = requiredImpression &&
            impression.toLowerCase() !== requiredImpression.toLowerCase();
        if (isImpressionInvalid) {
            return isInitials
                ? "Please enter your initials as recorded in your profile: " + requiredImpression
                : "Please enter your full legal name as recorded in your profile: " + requiredImpression;
        }
        return '';
    };
    var impressionError = wasSubmitted
        ? getImpressionError(impression)
        : '';
    var handleSubmit = function () {
        setWasSubmitted(true);
        if (getImpressionError(impression))
            return;
        onSubmit(impression);
        onClose();
    };
    return (react_1.default.createElement(core_1.Dialog, { fullScreen: true, onClose: onClose, open: open, "data-tid": "DocumentPageSignatureInputDialog-root" },
        react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement(icons_1.Close, { onClick: onClose, className: classes.closeBtn }),
            react_1.default.createElement(core_1.Typography, { className: classes.title }, isInitials ? 'Initials' : 'Signature'),
            react_1.default.createElement(core_1.Typography, { className: classes.legalCopy },
                "Only the person associated with these records is permitted to use this system through this account. Completion and submission of the online forms available through this system will create legally binding obligations associated with each form. Please read each form carefully. Execution of each form will be accomplished through clicking on the \u201CI",
                ' ',
                isViewMoreOpen && (react_1.default.createElement("span", null, "Agree\u201D button provided at the bottom of each form. By clicking \u201CI Agree\u201D at the bottom of each form, you will be acknowledging that you have read the applicable form, understand the requirements for submission of the information, agree to submit complete and accurate information, and further agree to submit and sign these forms electronically through this system."))),
            react_1.default.createElement(core_1.Typography, { className: classes.viewMore, onClick: function () { return setIsViewMoreOpen(function (isViewMoreOpen) { return !isViewMoreOpen; }); } }, isViewMoreOpen ? 'Show less' : 'View More'),
            react_1.default.createElement("div", { className: classes.formFields },
                react_1.default.createElement(core_1.TextField, { className: classes.textField, "data-tid": "DocumentPageSignatureInputDialog-input", label: isInitials ? 'Initials' : 'Full Legal Name', margin: "normal", variant: "filled", InputLabelProps: {
                        className: classes.label,
                    }, InputProps: {
                        className: classes.input,
                    }, onChange: function (e) { return setImpression(e.target.value.trim()); } }),
                impressionError && (react_1.default.createElement(core_1.Typography, { className: classes.error, "data-tid": "DocumentPageSignatureInputDialog-error" }, impressionError))),
            react_1.default.createElement("div", { className: classes.btnContainer },
                react_1.default.createElement(core_1.Button, { onClick: onClose, className: classes.cancelBtn, "data-tid": "DocumentPageSignatureInputDialog-cancel" }, "Cancel"),
                react_1.default.createElement(core_1.Button, { onClick: handleSubmit, className: classes.agreeBtn, "data-tid": "DocumentPageSignatureInputDialog-submit" }, "I Agree")))));
};
exports.default = DocumentPageSignatureInputDialog;
//# sourceMappingURL=DocumentPageSignatureInputDialog.js.map